module.exports = __webpack_public_path__ + "img/Emissao-Cupom-Fiscal-Sat.29584b30.jpg";